import { render, staticRenderFns } from "./imagePreview2.vue?vue&type=template&id=db2f3cf6&scoped=true&"
import script from "./imagePreview2.vue?vue&type=script&lang=js&"
export * from "./imagePreview2.vue?vue&type=script&lang=js&"
import style0 from "./imagePreview2.vue?vue&type=style&index=0&id=db2f3cf6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2f3cf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db2f3cf6')) {
      api.createRecord('db2f3cf6', component.options)
    } else {
      api.reload('db2f3cf6', component.options)
    }
    module.hot.accept("./imagePreview2.vue?vue&type=template&id=db2f3cf6&scoped=true&", function () {
      api.rerender('db2f3cf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/imagePreview2.vue"
export default component.exports